module.exports = __webpack_public_path__ + "static/img/drag-horizontal.554b72a0.svg";